export enum INTERVIEW_TOPICS {
  CUSTOM = 'custom-interview',
  BEHAVIOURAL = 'behavioural',
  FIT = 'fit-interview',
  DATA_SCIENCE = 'data-science',
}

export interface Topic {
  label: string;
  value: INTERVIEW_TOPICS;
  description: string;
  numberOfQuestions: number;
  numberOfFollowUps: number;
  expectedTime: string;
  resourcesComponent: React.FC | null;
  dynamic?: boolean;
}
